/**
 * Transport glyphs, pinned to TEXT presentation.
 *
 * ── WHY THE VARIATION SELECTOR ────────────────────────────────────────────
 * U+23EE (⏮) and U+23ED (⏭) carry `Emoji_Presentation=Yes` in the Unicode
 * data, which means a platform is entitled to render them as full-colour
 * emoji WITHOUT being asked. iOS does exactly that: both skip buttons came out
 * as Apple's blue-grey rounded emoji tiles, sitting next to a flat pink
 * play/pause and a monochrome shuffle/repeat — the one part of the transport
 * that did not belong to the design.
 *
 * U+FE0E (VARIATION SELECTOR-15) is the standard request for the TEXT
 * presentation of the preceding codepoint. It costs nothing on platforms that
 * already default to text (it is a zero-width, non-rendering selector) and
 * fixes the platforms that do not. `font-variant-emoji: text` expresses the
 * same intent in CSS but is still not supported on WebKit, which is precisely
 * the engine that needs it here.
 *
 * The play/pause pair (`▶` U+25B6, `‖` U+2016) is deliberately NOT listed:
 * both are `Emoji_Presentation=No` and already render as text everywhere, so
 * a selector on them would be cargo cult.
 *
 * @module
 */

/** Text-presentation VARIATION SELECTOR-15. */
const TEXT_PRESENTATION = '︎';

/** Previous-track glyph (U+23EE), forced to text presentation. */
export const PREV_GLYPH = `⏮${TEXT_PRESENTATION}`;

/** Next-track glyph (U+23ED), forced to text presentation. */
export const NEXT_GLYPH = `⏭${TEXT_PRESENTATION}`;
